import React from 'react';
import { Link } from 'react-router-dom';
import { nice06Keywords } from '../topKeywords';

export const Nice06: React.FC = () => {
  return (
    <div className="bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-2">
            Nice et Alpes Maritimes (06)
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            Nettoyage logement insalubre Nice 06 et syndrome de Diogène
          </h1>
          <p className="text-sm text-slate-600 mb-4 max-w-3xl">
            Interventions rapides sur Nice et l’ensemble des Alpes Maritimes pour le{' '}
            <strong>
              nettoyage de logements insalubres, maisons encombrées et syndrome de Diogène
            </strong>
            . Nous travaillons avec les familles, notaires, agences et syndics.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/devis"
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-800 transition-colors"
            >
              Devis nettoyage logement insalubre Nice
            </Link>
            <p className="text-xs text-slate-500">
              Nous intervenons notamment pour :{' '}
              <em>{nice06Keywords.slice(0, 3).join(', ')}</em>
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-10 lg:py-14 grid gap-8 lg:grid-cols-[1.7fr,1.3fr]">
        <div>
          <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-3">
            Nettoyage extrême et désinfection de logements insalubres à Nice
          </h2>
          <p className="text-sm text-slate-600 mb-3">
            Quand un logement devient insalubre à Nice – accumulation de déchets, odeurs fortes,
            humidité, présence de nuisibles – une intervention professionnelle est indispensable
            pour retrouver un environnement sain et conforme.
          </p>
          <p className="text-sm text-slate-600 mb-3">
            Nos équipes spécialisées interviennent sur tout type de configuration : appartements en
            centre-ville, studios étudiants, maisons individuelles ou logements sociaux. Nous
            gérons le débarras, le nettoyage extrême, la désinfection et la désodorisation.
          </p>
          <ul className="list-disc list-inside text-sm text-slate-600 mb-3">
            <li>Débarras complet et évacuation des déchets vers déchetterie agréée</li>
            <li>
              Nettoyage en profondeur des sols, murs, plafonds, cuisine et salle de bain
            </li>
            <li>Traitement des odeurs, désinfection et désinsectisation</li>
            <li>Photos avant/après pour notaires, agences et assurance</li>
          </ul>
          <p className="text-sm text-slate-600">
            Cette page vise notamment les recherches locales comme{' '}
            <strong>nettoyage logement insalubre Nice</strong>,{' '}
            <strong>nettoyage logement insalubre 06</strong> et{' '}
            <strong>nettoyage logement insalubre Alpes Maritimes</strong>, avec un contenu pensé
            pour les habitants et professionnels du département.
          </p>
        </div>

        <aside className="rounded-2xl border border-slate-200 bg-white p-5 text-xs text-slate-600">
          <h3 className="text-sm font-semibold text-slate-900 mb-2">
            Zone d’intervention Nice & 06
          </h3>
          <p className="mb-2">
            Intervention dans tout le département des Alpes Maritimes (06) : Nice, Cannes, Antibes,
            Cagnes-sur-Mer, Menton, Grasse, etc.
          </p>
          <p className="mb-2">
            Idéal pour répondre aux besoins de{' '}
            <em>
              nettoyage logement insalubre Nice, nettoyage extrême Nice, nettoyage Diogène Nice
            </em>
            , avec prise en charge complète du débarras à la désinfection.
          </p>
          <Link
            to="/devis"
            className="inline-flex items-center justify-center rounded-md bg-mint px-3 py-1.5 text-[11px] font-semibold text-slate-950 hover:bg-emerald-400 transition-colors"
          >
            Expliquer ma situation à Nice
          </Link>
        </aside>
      </section>
    </div>
  );
};
